import { TRPC_PATH } from "@/shared/consts";

export function transformTrpcUrl(
  url: string | URL | Request,
  baseUrl: string,
): string {
  const urlString =
    typeof url === "string"
      ? url
      : url instanceof URL
        ? url.toString()
        : url.url;
  const urlParsed = new URL(urlString);
  const path = urlParsed.pathname;

  const newUrl = new URL(baseUrl);

  urlParsed.searchParams.forEach((value, key) => {
    newUrl.searchParams.set(key, value);
  });

  let finalPath = path;

  if (path.includes(TRPC_PATH)) {
    const trpcIndex = path.indexOf(TRPC_PATH);
    finalPath = path.substring(trpcIndex);
  } else {
    const pathWithoutLeadingSlash = path.startsWith("/")
      ? path.substring(1)
      : path;
    const pathParts = pathWithoutLeadingSlash.split("/");

    if (pathParts.length > 1) {
      const endpoint = pathParts[pathParts.length - 1];
      finalPath = TRPC_PATH + "/" + endpoint;
    } else {
      finalPath = TRPC_PATH + path;
    }
  }

  newUrl.searchParams.set("path", finalPath);

  return newUrl.toString();
}
